import { gql } from '@apollo/client';

export const PROPERTY_AREA_FRAGMENT = gql`
  fragment PropertyArea on Property {
    area {
      bra
      braTo
      prom
      promTo
    }
  }
`;
